module.exports = "/img/welcome.487f8e12.svg";